import { useState, useEffect, useMemo } from "react"
import { Button, Form, Input, Upload, Select, DatePicker, Card, Col, Row, Checkbox, InputNumber } from "antd"
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

import { ROUTES, COMMON_FEATURES } from "../../../../../../../../constants"

import { uploadHDLR, report_handler } from "../../../../../../../../handlers"

import { REDUX, RoundUp, TIME } from '../../../../../../../../services/util'

// Style
import styles from './index.module.css'
import './index.css'

const { getBase64, handleBeforeUpload, UploadVehicleIssueImage } = uploadHDLR
const { mileageSelector, MILEAGE_TYPE } = report_handler
const { parseHours, getCurTimeDayJS } = TIME

const ServiceEntryForm = ({ form, onFinish, data, images, setImages, check, setCheck,
    //  vamReminders 
    }) => {

    const navigate = useNavigate()

    const { staticsByID, derivativeStateByID  } = useSelector(REDUX.reduxStoreWrapper('vehicles'))

    const vehicles = Object.values(staticsByID).map(v => ({ label: v.plate, value: v.vid }))
    const types = Object.values(useSelector(REDUX.reduxStoreWrapper('vamLines.itemByID'))).map(t => ({ label: t.name, value: t.vamlid }));

    const [isUploadReady, setIsUploadReady] = useState(false);
    const [vhc, setVhc] = useState(null)
    // const [line, setLine] = useState(null)

    useEffect(() => {
        if (data) {
            setImages(data?.photos || []);
            setVhc(data?.vid)
            // setLine(data?.vamlid)

            if(data?.issuedAt){
                setCheck(prev => ({ ...prev, issue: true }))
            }
        }
        setIsUploadReady(true); 
    }, [data])

    const handleChangeImg = (info) => {
        const { status, originFileObj, response = {} } = info.file;

        if (status === "uploading") {
            return;
        }
        if (status === "done") {
            getBase64(originFileObj, () => {
                const { url } = response;
                setImages((prevImages = []) => [...prevImages, {url}]);
            });
        }
    };

    const newFileList = useMemo(() =>
        (images || []).map(({ url }, index) => {
          if (!url) return null;
          return {
            uid: `${index}`,
            name: url.split('/').pop(),
            status: 'done',
            url,
          };
    }).filter(Boolean), [images]);

    const odometer = mileageSelector(derivativeStateByID?.[vhc], MILEAGE_TYPE.ODOMETER)
    const workingHrs = derivativeStateByID?.[vhc]?.plat_hist_engine_hour
    // const exists = Object.values(vamReminders).some(v => v.vid === vhc && v.vamlid === line);

    const initial = data ? 
    { ...data, vamlids: data.vamlids || data.vamlid, completedAt: dayjs(data?.completedAt), ...(data?.issuedAt ? {issuedAt: dayjs(data?.issuedAt)} : {})  } : 
    { completedAt: getCurTimeDayJS() }

    return (
        <Form 
            style={{ width: '50vw', minWidth: '60em', margin: '5em auto'}}
            labelCol={{ span: 5 }}
            form={form}
            initialValues={initial}
            onFinish={onFinish}
        >
            <Form.Item
                label="Vehicle Plate"
                name="vid"
                rules={[
                    {
                        required: true,
                        message: 'Please input vehicle plate!',
                    },
                ]}
                >
                    <Select options={vehicles} onChange={(val) => setVhc(val)}/>
            </Form.Item>
            <Form.Item
                label="Line Item"
                name="vamlids"
                rules={[
                    {
                        required: true,
                        message: 'Please input line item!',
                    },
                ]}
                >
                    <Select 
                        options={types}
                        mode='multiple' 
                        // onChange={(val) => setLine(val)}
                    />
            </Form.Item>
            <Form.Item
                label="Workshop"
                name="workshop"
                >
                    <Input size="large" />
            </Form.Item>
            <Form.Item
                label="Total Cost"
                name="total_cost"
                >
                    <InputNumber size="large" style={{ width: '100%'}}/>
            </Form.Item>
            <Form.Item
                label="Remark"
                name="remark"
                >
                    <Input size="large" />
            </Form.Item>

            {vhc && 
                <Card title={`${staticsByID[vhc].plate} Current Odometer and Working Hour`} style={{ margin: '0 0 25px 20%', width: '80%'}}>
                    <Row style={{ marginBottom: '20px'}}>
                        <Col flex={3}>{`Odometer: ${!isNaN(odometer) ? `${RoundUp(odometer, 0)} km` : "-"}`}</Col>
                        <Col flex={4}>{`Working Hour: ${!isNaN(Number(workingHrs)) ? `${RoundUp(parseHours(workingHrs), 0)} hrs` : "-"}`}</Col>
                    </Row>
                    <Form.Item
                        label="Completion Date"
                        name="completedAt"   
                        rules={[
                            {
                                required: true,
                                message: 'Please input completion date!',
                            },
                        ]}
                        >
                            <DatePicker />
                    </Form.Item>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px'}}>
                        <Checkbox onChange={(e) => setCheck(prev => ({ ...prev, issue: e.target.checked }))} checked={check?.issue}>Set Issued Date</Checkbox>
                        {check?.issue && (
                            <Row>
                            <Col span={18}>
                                <Form.Item
                                    label="Issued Date"
                                    name="issuedAt"   
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input issued!',
                                        },
                                    ]}
                                    >
                                        <DatePicker />
                                </Form.Item>
                            </Col>
                            </Row>
                        )}
                        {/* <Checkbox checked disabled>Marked At Completed</Checkbox>
                        <Checkbox onChange={(e) => setCheck(prev => ({ ...prev, reminder: e.target.checked }))} disabled={!exists}>
                            Manually set the due date, odometer and/or working for next reminder
                        </Checkbox>
                        {check?.reminder && (
                            <Row gutter={12}>
                            <Col span={10}>
                                <Form.Item
                                    label='Next Due Date'
                                    name="time_next" 
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input next due date!',
                                        },
                                    ]}
                                    labelCol={{ span: 11 }}
                                    wrapperCol={{ span: 16 }}
                                    style={{ marginBottom: 0 }}
                                    >
                                        <DatePicker style={{ marginLeft: '5px' }} />
                                </Form.Item>
                             </Col>
                            <Col span={12}>
                             <Form.Item
                                label='Next Odometer Due'
                                name="odometer_next" 
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input next odometer!',
                                    },
                                ]}
                                labelCol={{ span: 14 }}
                                wrapperCol={{ span: 16 }}
                                style={{ marginBottom: 0 }}
                                >
                                    <Input addonBefore="At" addonAfter="km" style={{ marginLeft: '5px', width: '140px' }} />
                                </Form.Item>
                            </Col>
                            </Row>
                        )} */}
                    </div>
                </Card>
            }

            <Form.Item
                label="Attachment"
                name="photos"
                > 
                    {isUploadReady && (
                        <Upload
                            listType="picture-card"
                            defaultFileList={newFileList}
                            beforeUpload={handleBeforeUpload}
                            onChange={handleChangeImg}
                            customRequest={UploadVehicleIssueImage}
                        >
                            {'+ Upload'}
                        </Upload>
                    )}
            </Form.Item>

                <div className={styles['button-container']} style={{ marginBottom: '50px'}}>
                    <Button className={`${styles['button']} ${styles['cancel']}`} onClick={() => navigate(ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.VEHICLE_ENTRY_MANAGEMENT])}>Cancel</Button>
                    <Button className={`${styles['button']} ${styles['add']}`} htmlType="submit">Add</Button>
                </div>
        </Form>
    )
}

export default ServiceEntryForm;